import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/app/layoutClientBody.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/app/layoutClientFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/app/layoutClientHeader.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/jsvectormap/dist/jsvectormap.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/flatpickr/dist/flatpickr.min.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/css/satoshi.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/css/style.css");
